export class ItemRequest {
    itemId: number;
    unitId?: number;
    saleOrderId?: number;
    locationId?: number;
    saleOrderItemId?: number;
    stockType?:string

    constructor(itemId: number, unitId?: number, saleOrderId?: number, locationId?: number,saleOrderItemId?: number,stockType?:string) {
        this.itemId = itemId;
        this.unitId = unitId;
        this.saleOrderId = saleOrderId;
        this.locationId = locationId;
        this.saleOrderItemId = saleOrderItemId;
        this.stockType = stockType;

    }
}